import { render, staticRenderFns } from "./TableViewer.vue?vue&type=template&id=59014f5c&scoped=true&"
import script from "./TableViewer.vue?vue&type=script&lang=js&"
export * from "./TableViewer.vue?vue&type=script&lang=js&"
import style0 from "./TableViewer.vue?vue&type=style&index=0&id=59014f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59014f5c",
  null
  
)

export default component.exports